<div [hidden]="!loader.loading()">
  <div class="loader-page-center-overlay">
    <fa-icon [icon]="faSpinner" animation="spin" size="5x"></fa-icon>
  </div>
</div>
